// <ako-quantity-selector>
class AkoQuantitySelector extends HTMLElement {
  constructor() {
    super();

    this.decreaseButton = this.querySelector('[data-ako-action="decrease"]');
    this.increaseButton = this.querySelector('[data-ako-action="increase"]');
    this.quantityInput = this.querySelector('.ako-quantity-selector__input');

    this.decreaseButton.addEventListener('click', this.decrease.bind(this));
    this.increaseButton.addEventListener('click', this.increase.bind(this));
    this.quantityInput.addEventListener('input', this.handleInput.bind(this));
    this.quantityInput.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  get quantity() {
    return parseInt(this.getAttribute('quantity')) || 0;
  }

  set quantity(value) {
    this.setAttribute('quantity', value);
    this.quantityInput.value = value;
  }

  decrease() {
    if (this.quantity > 0) {
      this.quantity -= 1;
      this.dispatchEvent(new Event('custom:input:change'));
    }
  }

  increase() {
    this.quantity += 1;
    this.dispatchEvent(new Event('custom:input:change'));
  }

  handleInput() {
    const value = parseInt(this.quantityInput.value) || 0;
    this.quantity = value;
    this.dispatchEvent(new Event('custom:input:change'));
  }

  handleKeyDown(event) {
    event.key === 'ArrowUp' ? this.increase() :
    event.key === 'ArrowDown' ? this.decrease() :
    event.key === 'Enter' ? this.handleInput() :
    null;
  }

  connectedCallback() {
    this.quantity = this.quantity; // Trigger initial rendering
  }
}

if (!window.customElements.get("ako-quantity-selector")) {
window.customElements.define("ako-quantity-selector", AkoQuantitySelector);
}



// <ako-quantity-component>
class AkoQuantityComponent extends HTMLElement {
constructor() {
  super();

  // Food and max quantity value
  this.foodType = this.querySelector('[data-food-type]').getAttribute('data-food-type');
  this.maxQuantity = this.querySelector('[data-ako-quantity]').getAttribute('data-ako-quantity');
  this.exceedMessage = this.getAttribute('data-exceed-message') || '您的總數量已超過 {max} 了';
  this.foodTotal = 0;
  this.currentValue = 0;

  // Quantity inputs and buttons
  this.quantityInputs = this.querySelectorAll('.ako-quantity-selector__input');
  this.increaseButtons = this.querySelectorAll('[data-ako-action="increase"]');
  this.quantityButtons = this.querySelectorAll('.quantity-selector__button');
  this.akoSubmitButton = document.querySelector('#ako-submit-button')
  this.akoSubmiterrorMessage = document.querySelector('#ako-submit-error-message')

  // Counter and error message
  this.akoSelectorCountElement = this.querySelector('[data-ako-action="count-total"]');
  this.errorContainer = this.querySelector('.ako-error-container');
  this.errorMessage = this.querySelector('.ako-error');
  this.errorTimeoutContainer = this.querySelector('.ako-error-container[is="timeout"]');
  this.errorTimeoutMessage = this.querySelector('.ako-error[is="timeout"]');

  this.addEventListeners()
  this.checkAllItemsMaxed() 
  this._installDisabledGuardian()
}

 _installDisabledGuardian() {
   if (AkoQuantityComponent._guardianInstalled) return;
   AkoQuantityComponent._guardianInstalled = true;

   const btn = this.akoSubmitButton;
   if (!btn) return;

   const isBundleReady = () => {
     const allItems = document.querySelectorAll('ako-quantity-component');
     for (const item of allItems) {
       if (parseInt(item.foodTotal) !== parseInt(item.maxQuantity)) return false;
     }
     return true;
   };

   new MutationObserver(() => {
     if (!isBundleReady() && !btn.disabled) {
       btn.disabled = true;
     }
   }).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
 }
 
updateTotalQuantity(input, event) {

  if (!this.foodType) {
    console.error('Error: Unable to find elements with data-food-type attribute');
    return;
  }

  const inputValue = parseInt(input.value) || 0;

  this.currentValue =
    event.key === "ArrowUp" || event.target.closest('[data-ako-action="increase"]') !== null ? 1 :
    event.key === "ArrowDown" || event.target.closest('[data-ako-action="decrease"]') !== null ? -1 :
    inputValue - this.foodTotal;

  console.log('current value', this.currentValue)
  console.log('foodTotal before calculation', this.foodTotal)

  function calculateTotalFood(inputs) {
    let total = 0;
    inputs.forEach((input) => {
        total += parseInt(input.value) || 0;
    });
    return total;
  }

  if (this.foodTotal + this.currentValue > this.maxQuantity) {

    this.errorTimeoutContainer.style.display = "flex"
    this.errorTimeoutMessage.innerText = this.exceedMessage.replace('{max}', this.maxQuantity)

    if (event.key == "ArrowUp" || event.target.closest('[data-ako-action="increase"]') != null) {
      event.preventDefault();
      this.currentValue = 0;
      input.value -= 1;
      input.parentElement.quantity -= 1;
    } else {
      this.currentValue = 0;
      input.value = 0;
      input.parentElement.quantity = 0;
    }

    setTimeout(() => {
      this.errorTimeoutContainer.style.display = "none"
    }, 2000)
  }

  this.foodTotal = calculateTotalFood(this.quantityInputs);
  console.log('foodTotal after calculation:', this.foodTotal);


  // Doublecheck to make sure the food total is not > max quantity
  if (this.foodTotal > this.maxQuantity) {

    this.errorTimeoutContainer.style.display = "flex"
    this.errorTimeoutMessage.innerText = this.exceedMessage.replace('{max}', this.maxQuantity)

    this.currentValue = 0;
    input.value = 0;
    input.parentElement.quantity = 0;

    setTimeout(() => {
      this.errorTimeoutContainer.style.display = "none"
    }, 2000)

    this.foodTotal = calculateTotalFood(this.quantityInputs);
  }

  if (this.foodTotal >= this.maxQuantity) {
    this.increaseButtons.forEach(button => button.disabled = true);
    this.errorContainer.style.display = "flex"
    console.log('max food reached')
  } else if (this.foodTotal < this.maxQuantity) {
    this.increaseButtons.forEach(button => button.disabled = false);
    this.errorContainer.style.display = "none"
  }

  this.akoSelectorCountElement.innerText = this.foodTotal;
  if (this.foodTotal == this.maxQuantity){
    this.checkAllItemsMaxed();
  } else {
    this.akoSubmitButton.disabled = true
    this.akoSubmiterrorMessage.style.display = "flex"
  }

}

checkAllItemsMaxed() {
  const allItems = document.querySelectorAll('ako-quantity-component');

  for (const item of allItems) {
    if (parseInt(item.foodTotal) !== parseInt(item.maxQuantity)) {
      this.akoSubmitButton.disabled = true
      this.akoSubmiterrorMessage.style.display = "flex"
      return;
    }
  }
  this.akoSubmitButton.disabled = false
  this.akoSubmiterrorMessage.style.display = "none"
}

addEventListeners() {
  this.quantityInputs.forEach(input => {

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      input.addEventListener('input', (event) => this.updateTotalQuantity(input,event));
    } else {
      input.addEventListener('change', (event) => this.updateTotalQuantity(input,event));
    }

    input.addEventListener('keydown', event => {
      if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        this.updateTotalQuantity(input, event);
      }
    });
  });

  this.quantityButtons.forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();

      const input = button.closest('.quantity-selector').querySelector('.ako-quantity-selector__input');

      // If the event is not prevented, update the total quantity
      this.updateTotalQuantity(input, event);
    });
  });

  this.akoSubmitButton.addEventListener('click', async () => {
     if (!AkoQuantityComponent.isSubmittingForm) {
      AkoQuantityComponent.isSubmittingForm = true;
      await this.submitForm();
      AkoQuantityComponent.resetAllComponents();
      AkoQuantityComponent.isSubmittingForm = false;
    }
  })
}

async submitForm() {
    const submitButtons = document.querySelectorAll('[type="submit"]');
    submitButtons.forEach((submitButton) => {
      submitButton.setAttribute("disabled", "disabled");
      submitButton.setAttribute("aria-busy", "true");
    });
    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

    const bundleItemsFlavors = document.querySelectorAll('ako-quantity-selector');
    const productFormBundle = document.querySelector('.product-form__bundle');
    let randomBundleID = Date.now();
    let mainBundleID

    productFormBundle ? mainBundleID = productFormBundle.id : console.error('no product form bundle found')

    let akoFormData = {
      'items': [
        {
          'id': mainBundleID,
          'quantity': 1,
          'properties': {
            "_isBundle": true,
            "_bundleID": randomBundleID,
          }
        }
      ],
      'sections': sectionsToBundle.join(","),
      'sections_url': `${Shopify.routes.root}variants/${mainBundleID}`,
    };

    let flavorArr = Array.from(bundleItemsFlavors)
    .filter(flavour => {
      if (flavour.quantity !== 0) {
        return flavour
      }
    }).map(flavour => {
      return {
        'id': flavour.id,
        'quantity': flavour.quantity,
        'properties': {
          "_isBundleItem": true,
          "_bundleID": randomBundleID,
        }
      }
    })


    akoFormData['items'] = [...flavorArr, ...akoFormData['items']];

    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: JSON.stringify(akoFormData),
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        'Content-Type': 'application/json',
        // Needed for Shopify to check inventory
      }
    });
    submitButtons.forEach((submitButton) => {
      submitButton.removeAttribute("disabled");
      submitButton.removeAttribute("aria-busy");
    });

    const responseJson = await response.json();
    if (response.ok) {

      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        return window.location.href = `${Shopify.routes.root}cart`;
      }
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent["sections"] = responseJson["sections"];
      document.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent
        }
      }));
    } else {
      document.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: {
          error: responseJson["description"]
        }
      }));
    }

}

static resetAllComponents() {
  const allComponents = document.querySelectorAll('ako-quantity-component');
  allComponents.forEach(component => component.resetForm());
}

resetForm = () => {
  this.quantityInputs.forEach(input => {
    input.value = 0;
    input.parentElement.quantity = 0;
  });
  this.foodTotal = 0
  this.currentValue = 0
  this.akoSelectorCountElement.innerText = 0
  this.increaseButtons.forEach(button => button.disabled = false)
  this.akoSubmitButton.disabled = true
  this.akoSubmiterrorMessage.style.display = "flex"
  this.errorContainer.style.display = "none"
}
}

customElements.define('ako-quantity-component', AkoQuantityComponent);
